module.exports = __webpack_public_path__ + "img/lady-01.ac7bc3c1.svg";